import './../my-theme/index.less';
import Vue from 'vue';
import iView from 'iview';
import router from './router';
import store from './store.js';
import App from './app.vue';
import 'lib-flexible/flexible';
import Moment from 'moment';
// import 'iview/dist/styles/iview.css';

import VueI18n from 'vue-i18n';
import zhcn from './locale/zh_cn.js';
import enus from './locale/en_us.js';
import zhLocale from 'iview/src/locale/lang/zh-CN';
import enLocale from 'iview/src/locale/lang/en-US';
const messages = {
    'zh-cn': Object.assign(zhcn, zhLocale),
    'en-us': Object.assign(enus, enLocale)
};

import VueKonva from 'vue-konva';

//引入实用工具模块
import * as Util from './libs/util';
Vue.prototype.$util = Util;

Vue.use(VueKonva);

Vue.use(VueI18n);
// Vue.use(iView);

Vue.locale = () => {};

// 多语言设置
const i18n = new VueI18n({
    locale: 'zh-cn', // 默认语言
    messages
});
Vue.use(iView, {
    i18n: (key, value) => i18n.t(key, value)
});

// 全局过滤器
// 格式化数字
Vue.filter('format', function(value, zoom, fixed, label) {
    if (isNaN(value)) {
        return '--' + label;
    }
    let num = new Number(value);
    return (num / zoom).toFixed(fixed) + label;
});
//格式化时间
Vue.filter('formatTime', function(value) {
    return Moment(value).format('YYYY-MM-DD HH:mm:ss');
});

new Vue({
    el: '#app',
    router,
    store,
    i18n, // i18n
    render: h => h(App),
    data() {
        return {
            deviceKind: [
                {
                    value: 1,
                    name: this.$t('b_MoldTemp')
                },
                {
                    value: 2,
                    name: this.$t('b_ThreeMachineDF')
                },
                {
                    value: 3,
                    name: this.$t('b_CoolingWater')
                },
                {
                    value: 4,
                    name: this.$t('b_Cadryer')
                },
                {
                    value: 5,
                    name: this.$t('b_ConveyorBelt')
                },
                {
                    value: 6,
                    name: this.$t('b_AutoFeedingController')
                },
                {
                    value: 7,
                    name: this.$t('b_Robot1100')
                },
                {
                    value: 8,
                    name: this.$t('b_InjectionJSU')
                },
                {
                    value: 9,
                    name: this.$t('b_TMC')
                },
                {
                    value: 10,
                    name: this.$t('b_Dryer')
                },
                {
                    value: 12,
                    name: this.$t('b_InjectionKLS')
                },
                {
                    value: 13,
                    name: this.$t('b_Robot990')
                },
                {
                    value: 14,
                    name: this.$t('b_ThreeMachineSF')
                },
                {
                    value: 20,
                    name: this.$t('b_Mold')
                },
                {
                    value: 21,
                    name: this.$t('b_AutoDetection')
                }
            ]
        }
    },
    beforeCreate() {
        // 排除刷新导致的数据丢失
        if (this.$store.state.user == null) {
            this.$store.commit('upUser', sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : {});
            // this.$store.commit('upFID', sessionStorage.getItem('fid') ? sessionStorage.getItem('fid') : 0);
            this.$i18n.locale = sessionStorage.getItem('lang') ? sessionStorage.getItem('lang') : 'zh-cn';
        }
    },
    computed: {
        deviceKindArr(){
            let arr = new Array(22);
            this.deviceKind.forEach(item => {
                arr[item.value] = item.name;
            });
            return arr;
        }
    }
});



// WEBPACK FOOTER //
// ./src/main.js